import React from "react";
import { Loader2 } from "lucide-react";
import { CANVAS_WIDTH, CANVAS_HEIGHT } from "./utils";

export interface LoadingStoryboard {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

interface LoadingSpinnerProps {
  loadingStoryboard: LoadingStoryboard;
  maxZIndex: number;
}

export function LoadingSpinner({
  loadingStoryboard,
  maxZIndex,
}: LoadingSpinnerProps): React.ReactNode {
  return (
    <div
      className="absolute flex flex-col items-center justify-center"
      style={{
        position: "absolute",
        left: CANVAS_WIDTH / 2 + loadingStoryboard.x,
        top: CANVAS_HEIGHT / 2 + loadingStoryboard.y,
        width: loadingStoryboard.width,
        height: loadingStoryboard.height,
        zIndex: maxZIndex + 100,
      }}
    >
      <Loader2 className="w-8 h-8 animate-spin text-primary-0"></Loader2>
    </div>
  );
}
LoadingSpinner.displayName = "LoadingSpinner";
